// extracted by mini-css-extract-plugin
export default {"btn":"EditButton_btn__9wvD0"};